import { defineStore } from 'pinia'

import { STORAGE_KEYS, DATA_SCOPES } from '@/utils/constants'

// Scope hierarchy — a wider scope satisfies any narrower requirement.
const SCOPE_RANK = {
  [DATA_SCOPES.OWN]: 1,
  [DATA_SCOPES.DEPARTMENT]: 2,
  [DATA_SCOPES.HOTEL]: 3
}

// Accepts 'module.action' strings or { code, scope } objects.
function normalize(list) {
  return (list || []).map((p) =>
    typeof p === 'string'
      ? { code: p, scope: null }
      : { code: p.code, scope: p.scope || null }
  )
}

export const usePermissionsStore = defineStore('permissions', {
  state: () => ({
    permissions: normalize(
      JSON.parse(localStorage.getItem(STORAGE_KEYS.PERMISSIONS) || '[]')
    )
  }),

  getters: {
    // can('reservation.create') or can('reservation.delete', DATA_SCOPES.HOTEL)
    can: (state) => (code, requiredScope = null) => {
      const match = state.permissions.find((p) => p.code === code)
      if (!match) return false
      if (!requiredScope) return true
      return (SCOPE_RANK[match.scope] || 0) >= (SCOPE_RANK[requiredScope] || 0)
    },

    canAny: (state) => (codes = []) =>
      codes.some((code) => state.permissions.some((p) => p.code === code)),

    canAll: (state) => (codes = []) =>
      codes.every((code) => state.permissions.some((p) => p.code === code)),

    scopeFor: (state) => (code) => {
      const match = state.permissions.find((p) => p.code === code)
      return match ? match.scope : null
    }
  },

  actions: {
    setPermissions(list) {
      this.permissions = normalize(list)
      localStorage.setItem(
        STORAGE_KEYS.PERMISSIONS,
        JSON.stringify(this.permissions)
      )
    },

    clear() {
      this.permissions = []
      localStorage.removeItem(STORAGE_KEYS.PERMISSIONS)
    }
  }
})
